/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {createContext, use} from 'react'

export type User = {
  avatarUrl: string
  id: string
  login: string
  name: string
  is_emu: boolean
  analyticsTrackingId?: string | null
}

export type UserHookPayload = {
  current_user: User
}

/** Supplies the viewer on data-router routes, which have no app payload to read. */
export const UserContext = createContext<User | null>(null)

export const useUser = () => {
  const payload = useAppPayload<UserHookPayload>()
  const providedUser = use(UserContext)
  const currentUser = providedUser ?? (payload && payload.current_user ? payload.current_user : null)

  return {currentUser}
}
